import DOMPurify from 'dompurify';
import HTMLReactParser from 'html-react-parser';

import { SafeHtmlProps } from './safeHtml.types';

const SHOP_RICH_TEXT_SANITIZE_CONFIG = {
  ALLOW_ARIA_ATTR: false,
  ALLOW_DATA_ATTR: false,
  ALLOWED_ATTR: ['href'],
  ALLOWED_TAGS: [
    'a',
    'blockquote',
    'br',
    'em',
    'h2',
    'h3',
    'h4',
    'li',
    'ol',
    'p',
    'strong',
    'u',
    'ul'
  ],
  ALLOWED_URI_REGEXP: /^(?:https:\/\/|mailto:)/i,
  FORBID_ATTR: ['ping', 'srcset', 'style']
};

const SafeHtml: React.FC<SafeHtmlProps> = ({ html, policy = 'default' }) => {
  const sanitized =
    policy === 'shopRichText'
      ? DOMPurify.sanitize(html, SHOP_RICH_TEXT_SANITIZE_CONFIG)
      : DOMPurify.sanitize(html);
  // eslint-disable-next-line no-restricted-syntax
  const parsed = HTMLReactParser(sanitized);

  return <>{parsed}</>;
};

export default SafeHtml;
